import { initialOrderState } from '../../data/data';
import { IOrderViewModel } from '../../models/create-orders/order.interface';
import { createStore } from '../store';

export const {
  Provider: OrderProvider,
  useStore,
  useSetStore
} = createStore<IOrderViewModel>(initialOrderState);
